import { render, staticRenderFns } from "./WelfarePatternMenu.vue?vue&type=template&id=9507aa70&scoped=true"
import script from "./WelfarePatternMenu.vue?vue&type=script&lang=js"
export * from "./WelfarePatternMenu.vue?vue&type=script&lang=js"
import style0 from "./WelfarePatternMenu.vue?vue&type=style&index=0&id=9507aa70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9507aa70",
  null
  
)

export default component.exports